module.exports = __webpack_public_path__ + "img/vignettes-asso_0009_claire-amitie.75f0f9b6.jpg";